// extracted by mini-css-extract-plugin
module.exports = {"btn":"FullScreenButton_btn__2B_l_"};